import React, {useEffect} from 'react';
import {Card, Form, Input, Typography} from "antd";
import useMortgage from "../../../providers/mortgage/useMortgage";
import useBackendUsers from "../../../providers/mortgage/useBackendUsers";
import dayjs from 'dayjs';

export function extractDateDescriptionAmountFromStringOld(input) {
    const patterns = [
        // Day-Month-Year formats (with month as string)
        /^(\d{1,2})[\s\-\/\.]?([A-Za-z]{3})[\s\-\/\.]?(\d{4})/,
        // Day-Month-Year numeric
        /^(\d{1,2})[\s\-\/\.]?(\d{2})[\s\-\/\.]?(\d{4})/,
        // Year-Month-Day
        /^(\d{4})[\s\-\/\.]?(\d{2})[\s\-\/\.]?(\d{2})/,
    ];

    const monthMap = {
        jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
        jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11,
    };

    input = input.trim();
    for (const pattern of patterns) {
        const match = input.match(pattern);

        if (match) {
            let [fullMatch, part1, part2, part3] = match;

            let date;
            if (/[A-Za-z]{3}/.test(part2)) {
                const monthIndex = monthMap[part2.toLowerCase()];
                if (monthIndex === undefined) continue;
                date = new Date(parseInt(part3), monthIndex, parseInt(part1));
            } else if (parseInt(part1) <= 31 && parseInt(part2) <= 12) {
                date = new Date(parseInt(part3), parseInt(part2) - 1, parseInt(part1));
            } else if (parseInt(part1) > 999) {
                date = new Date(parseInt(part1), parseInt(part2) - 1, parseInt(part3));
            }
            if (date && !isNaN(date)) {
                const remaining = input.slice(fullMatch.length).trim();

                // Extract the last number with decimal (with optional currency sign)
                const amountMatch = remaining.match(/([^\s\d\-]?\d[\d,]*\.\d{2})\s*$/);
                const amount = amountMatch ? amountMatch[1] : null;

                const description = amountMatch
                    ? remaining.slice(0, amountMatch.index).trim()
                    : remaining;

                return {date, description, amount};
            }
        }
    }

    return {date: null, description: null, amount: null};
}
export function extractDateDescriptionAmountFromString(input) {
    input = input.trim();

    // Date at start of string
    const dateRegex = /^(\d{1,2})\s*(?:[\/\-\.]\s*|\s+)?(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec|\d{2})\s*(?:[\/\-\.]\s*|\s+)?(\d{4})/i;
    const monthMap = {
        jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
        jul: 6, aug: 7, sep: 8, sept: 8, oct: 9, nov: 10, dec: 11,
    };

    const match = input.match(dateRegex);
    if (!match) {
        return { date: null, description: null, amount: null };
    }

    const [fullMatch, dayStr, monthStr, yearStr] = match;

    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);

    let month;
    if (/\d{2}/.test(monthStr)) {
        month = parseInt(monthStr, 10) - 1;
    } else {
        month = monthMap[monthStr.toLowerCase()];
    }

    if (month == null) {
        return { date: null, description: null, amount: null };
    }

    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
        return { date: null, description: null, amount: null };
    }

    const remaining = input.slice(fullMatch.length).trim();

    // Amount at end of string
    const amountMatch = remaining.match(/([^\s\d\-]?\d[\d,]*\.\d{2})\s*$/);
    const amount = amountMatch ? amountMatch[1] : null;

    const description = amountMatch
        ? remaining.slice(0, amountMatch.index).trim()
        : remaining;

    return { date, description, amount };
}

export const onPasteAppendFloat = (e) => {
    e.preventDefault();

    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    const cleaned = pasted.replace(/[^\d.-]/g, '').replace(/(?!^)-/g, '');
    const numericValue = parseFloat(cleaned);
    if (isNaN(numericValue)) return;

    const formatted = numericValue.toFixed(2);
    const input = e.target;

    const existing = input.value || '';
    const separator = existing.endsWith('\n') || existing === '' ? '' : '\n';
    const updated = existing + separator + formatted;

    // Set value programmatically
    const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
    nativeSetter.call(input, updated);
    input.dispatchEvent(new Event('input', {bubbles: true}));

    // Move cursor to end
    requestAnimationFrame(() => {
        input.setSelectionRange(updated.length, updated.length);
    });
};

function InstaQuery({section, uploadID, close}) {

    const mortgage = useMortgage()
    const {me} = useBackendUsers()
    const [state, setState] = React.useState({
        drafts: [],
        busy: false
    });
    const [form] = Form.useForm()
    const [inputValue, setInputValue] = React.useState('');
    const actions = {
        'c': 'Deposit',
        'd': 'Outgoing',
        'u': 'Unpaid Item'
    }
    const handleChange = (e) => {

        setInputValue(e.target.value.trim())
    }
    const owner = section.applicant === 1 ? mortgage.applicant1.firstName + `'s` : mortgage.applicant2.firstName + `'s`
    const a = (string) => {
        if (string[0].toLowerCase() === 'a' || string[0].toLowerCase() === 'e' || string[0].toLowerCase() === 'i' || string[0].toLowerCase() === 'o' || string[0].toLowerCase() === 'u') {
            return `an ${string}`
        }
        return `a ${string}`
    }

    const handleFinish = async (values) => {

        // if (!values.drafts || values.drafts.length === 0) {
        //     console.warn('No drafts to create queries from');
        //     return;
        // }
        // setState(s => ({...s, busy: true}));
        // const creates = values.drafts.map(item => {
        //     console.log({item})
        //     const newQuery = {
        //         target: 'queries',
        //         pairs: {
        //             mortgageID: mortgage.id,
        //             createdBy: me.sub,
        //             title: item.description === "Unpaid Item" ? item.description : 'Unknown ' + item.description,
        //             description: `Provide more info for ${a(item.description)} on ${owner} ${section.title}`,
        //             query: (item.query || '').split('\n'),
        //             userAnswered: 0,
        //             adminAnswered: 0,
        //             stage: section.stage,
        //             amount: Number(item.amount),
        //             index: section.index,
        //             section: section.name,
        //             date: item.date,
        //             referenceType: 'UPLOAD',
        //             referenceId: uploadID,
        //             reoccurring: item.reoccurring || false,
        //             adjustmentDirection: item.adjustmentDirection || null,
        //             adjustmentAmount: parseFloat(item.adjustmentAmount),
        //             adjustmentList: item.adjustmentList ? item.adjustmentList.split('\n').map(part => parseFloat(part)).filter(n=>n!=null) : null,
        //         }
        //     }
        //     if (item.private || item.description === "Unpaid Item") {
        //         newQuery.pairs.private = true
        //     }
        //
        //     if (item.lenderAnswerText) {
        //         newQuery.pairs.private = true
        //         newQuery.pairs.adminAnswered = 1
        //         newQuery.pairs.lenderAnswer = item.lenderAnswerText.split('\n')
        //         newQuery.pairs.lenderAnswerBy = me.sub
        //         newQuery.pairs.lenderAnswerOn = (new Date()).toISOString()
        //     }
        //     return newQuery
        // })
        //
        // await mortgage.mutate({create: creates});
        // setState(s => ({...s, busy: false}));

    }

    const handleValueChanged = (changedValues, allValues) => {

    }

    const handleRecurringChange = (e) => {

        // reevaluate the adjustmentList for all drafts
        const drafts = form.getFieldValue('drafts') || [];
        const array = [...drafts]

        array.forEach(draft => {
            if (draft.reoccurring && !draft.adjustmentList) {
                draft.adjustmentList = draft.adjustmentAmount ? draft.adjustmentAmount + '\n' : '';
            }
            if (!draft.reoccurring && !!draft.adjustmentList) {
                const parts = draft.adjustmentList.split(/[^\d.]+/).filter(part => part.trim() !== '').map(part => parseFloat(part));
                draft.adjustmentAmount = parts[0].toFixed(2)
                draft.adjustmentList = null
            }
        })

        form.setFieldsValue({drafts: array});

    }

    const onAdjustmentListBlur = (e) => {
        const drafts = form.getFieldValue('drafts') || [];
        const array = [...drafts]

        array.forEach(draft => {
            if (draft.reoccurring && draft.adjustmentDirection != null) {
                // is there a preexisting - set the adjustmentList to the existing adjustment amount

                const parts = draft.adjustmentList.split(/[^\d.]+/).filter(part => part.trim() !== '').map(part => parseFloat(part));

                const sum = parts.reduce((acc, val) => acc + val, 0).toFixed(2);
                draft.adjustmentAmount = sum;
                draft.adjustmentList = parts.map(part => part.toFixed(2)).join('\n') + '\n';
            }
        })

        form.setFieldsValue({drafts: array});
    }

    const savingTimer = React.useRef(null);
    useEffect(() => {

        // Here you can handle the input change, e.g., update state or send to an API

        // does the line end with  d, c, or u?
        const lastChar = inputValue.trim().slice(-1).toLowerCase();
        if (!Object.keys(actions).includes(lastChar)) {
            console.warn('Line must end with d (debit), c (credit), or u (unpaid item)');
            return;
        }

        // remove the last character from the string
        let lineWithoutAction = inputValue.trim().slice(0, -1).trim();
        let reversal = false
        if (lineWithoutAction.toLowerCase().endsWith('r')) {
            lineWithoutAction = lineWithoutAction.slice(0, -1).trim();
            reversal = true
        }

        const {date, description, amount} = extractDateDescriptionAmountFromString(lineWithoutAction);

        if (date && description && amount) {
            if (savingTimer.current) {
                clearTimeout(savingTimer.current);
            }
            const day = dayjs(date);
            savingTimer.current = setTimeout(() => {
                setState(s => ({...s, busy: true}));
                const action = actions[lastChar]
                // const existing = form.getFieldValue("drafts") || [];
                //
                // const newItem = {
                //     date: dayjs(date),
                //     description,
                //     amount,
                //     action: actions[lastChar]
                // }
                // if (reversal) {
                //     newItem.adjustmentDirection = lastChar === 'd' ? AdjustmentDirections.UP : AdjustmentDirections.DOWN;
                //     newItem.adjustmentAmount = amount;
                // }
                // newItem.query = `Please let us know the reason for the ${newItem.action.toLowerCase()} "${newItem.description}" for ${newItem.amount} on ${newItem.date.format("D MMM YYYY")}.`
                // newItem.description = newItem.action
                // newItem.date = newItem.date.format("YYYY-MM-DD")
                //
                // existing.unshift(newItem)
                // form.setFieldsValue({"drafts": existing});
                //setState(s=> ({...s, drafts: [...s.drafts, {date, description, amount, action: actions[lastChar]}]}));

                const newQuery = {
                    target: 'queries',
                    pairs: {
                        mortgageID: mortgage.id,
                        createdBy: me.sub,
                        title: description === "Unpaid Item" ? description : 'Unknown ' + description,
                        description: `Provide more info`,
                        query: [`Please let us know the reason for the ${action.toLowerCase()} "${description}" for ${amount} on ${dayjs(date).format("D MMM YYYY")}.`],
                        userAnswered: 0,
                        adminAnswered: 0,
                        stage: section.stage,
                        amount: Number(amount),
                        index: section.index,
                        section: section.name,
                        date: day.format('YYYY-MM-DD'),
                        referenceType: 'UPLOAD',
                        referenceId: uploadID,
                        reoccurring: false,
                        adjustmentDirection: null,
                        adjustmentAmount: null,
                        adjustmentList: null,
                    }
                }
                mortgage.mutate({create: newQuery}, (res) => {
                    setInputValue('')
                })
            }, 200);
        }
    }, [inputValue]);
    return (
        <Card color="blue">
            <Typography.Title level={5} className="m-0">Statement Queries</Typography.Title>
            <Typography.Paragraph>Paste a copy of the row, End the line with full decimal number followed by:</Typography.Paragraph>
            <div className="d-col">
                <Typography.Paragraph className="m-0"><strong>d</strong> - debit</Typography.Paragraph>
                <Typography.Paragraph className="m-0"><strong>rd</strong> - reverse debit : adj savings rate up</Typography.Paragraph>
                <Typography.Paragraph className="m-0"><strong>c</strong> - credit</Typography.Paragraph>
                <Typography.Paragraph className="m-0"><strong>rc</strong> - reverse credit : adj savings rate down</Typography.Paragraph>
            </div>

            <Input style={{width: '100%'}} onChange={handleChange} value={inputValue}/>

        </Card>
    )
}

export default InstaQuery;